import LayoutBase from './layoutbase.vue';
import StandardBill from './standardbill.vue';
import OcmStandardBill from './ocmstandardbill.vue';
import ReportBase from './reportbase.vue';
export {StandardBill,OcmStandardBill,LayoutBase,ReportBase};


// WEBPACK FOOTER //
// ./src/components/layout/index.js